import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { toast } from 'react-toastify';

/**
 * Export data to Excel
 * @param {Array} data - Array of objects to export
 * @param {Array} columns - Array of column definitions { title, field }
 * @param {String} filename - Name of the file without extension
 */
export const exportToExcel = (data, columns, filename) => {
  try {
    if (!data || data.length === 0) {
      toast.warning('No data to export');
      return;
    }

    // Map data to match column structure
    const exportData = data.map(item => {
      const row = {};
      columns.forEach(col => {
        // Handle nested fields (e.g., 'user.name') if necessary, 
        // but typically 'field' is flat. If render function exists, we might need value.
        // For simplicity, we mostly rely on direct field access or flatten data before passing.
        // If the column uses a render function, we might prioritize a 'exportValue' or just the raw field.
        
        // Simple property access
        row[col.title] = item[col.field] === undefined || item[col.field] === null ? '' : item[col.field];
      });
      return row;
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
    
    // Generate buffer and save
    XLSX.writeFile(workbook, `${filename}_${new Date().toISOString().slice(0, 10)}.xlsx`);
    toast.success('Excel export started');
  } catch (error) {
    console.error('Export Excel Error:', error);
    toast.error('Failed to export Excel');
  }
};

/**
 * Export data to PDF using jsPDF and AutoTable
 * @param {Array} data - Array of objects to export
 * @param {Array} columns - Array of column definitions { title, field }
 * @param {String} filename - Name of the file without extension
 * @param {String} title - Title to display in the PDF
 */
export const exportToPDF = (data, columns, filename, title = 'Export') => {
  try {
    if (!data || data.length === 0) {
      toast.warning('No data to export');
      return;
    }

    const doc = new jsPDF();

    // Title
    doc.setFontSize(18);
    doc.text(title, 14, 22);
    doc.setFontSize(11);
    doc.setTextColor(100);
    const dateStr = `Generated on: ${new Date().toLocaleString()}`;
    doc.text(dateStr, 14, 30);

    // Prepare table data
    const tableColumn = columns.map(col => col.title);
    const tableRows = data.map(item => {
      return columns.map(col => {
        const val = item[col.field];
        return val === undefined || val === null ? '' : String(val);
      });
    });

    // Generate table
    doc.autoTable({
      head: [tableColumn],
      body: tableRows,
      startY: 40,
      theme: 'grid',
      styles: { fontSize: 8, cellPadding: 2 },
      headStyles: { fillColor: [66, 66, 66] } // Dark gray header
    });

    doc.save(`${filename}_${new Date().toISOString().slice(0, 10)}.pdf`);
    toast.success('PDF export started');
  } catch (error) {
    console.error('Export PDF Error:', error);
    toast.error('Failed to export PDF');
  }
};
